const ar = {
  header: {
    selectLanguage: "اختر اللغة",
    languages: "اللغات",
  },
  hero: {
    tagline: "مسابقة تداول تجريبي من GODO",
    title: "أظهر مهاراتك في التداول واربح مكافآت حقيقية!",
    subtitle:
      "انضم إلى مسابقة التداول التجريبي من GODO، وتداول برصيد تجريبي قدره {balance}، وتفوق على المتداولين الآخرين، واحصل على حصتك من جائزة المسابقة!",
    participateNow: "شارك الآن",
    seeHowItWorks: "كيف تعمل المسابقة",
    trophiesAlt: "كؤوس المسابقة",
  },
  countdown: {
    competitionStart: "تبدأ المسابقة خلال",
    startedAt: "{date}",
    competitionEnds: "تنتهي المسابقة خلال",
    endsAt: "{date}",
    days: "يومًا",
    hours: "ساعات",
    minutes: "دقيقة",
    seconds: "ثانية",
  },
  prizes: {
    title: "الجوائز",
    subtitle:
      "تتشارك الحسابات الموثّقة المتصدرة جائزة قدرها {prizePool} دولار أمريكي عند إغلاق المسابقة.",
    totalPrizePool: "إجمالي الجوائز",
    firstPlace: "المركز الأول",
    secondPlace: "المركز الثاني",
    thirdPlace: "المركز الثالث",
    fourthPlace: "المركز الرابع",
    fifthPlace: "المركز الخامس",
    fivthPlace: "المركز الخامس",
    sixthPlace: "المركز السادس",
    seventhPlace: "المركز السابع",
    duration: "المدة",
    durationDay: "يوم واحد",
    durationDays: "{count} يومًا",
    durationWeek: "أسبوع واحد",
    durationWeeks: "{count} أسبوعًا",
    durationMonth: "شهر واحد",
    durationMonths: "{count} أشهر",
    startingBalance: "الرصيد الابتدائي",
    entry: "الاشتراك",
    entryValue: "مجاني",
    accounts: "الحسابات",
    accountsValue: "حساب واحد لكل متداول",
  },
  leaderboard: {
    title: "لوحة المتصدرين",
    rank: "الترتيب",
    trader: "المتداول",
    equity: "حقوق الملكية",
    profitLoss: "الربح / الخسارة",
    margin: "نسبة الأداء",
    drawdown: "نسبة التراجع",
    status: "الحالة",
    reason: "السبب",
    statusActive: "نشط",
    statusPending: "قيد الانتظار",
    statusDisqualified: "مستبعد",
    reasonNone: "—",
    reasonDrawdown: "تراجع 30% أو أكثر من أعلى رصيد",
    reasonLeftGroup: "غادر مجموعة المسابقة",
    rankUp: "ارتفاع في الترتيب",
    rankDown: "انخفاض في الترتيب",
    previous: "السابق",
    next: "التالي",
    previousPage: "الصفحة السابقة",
    pagination: "صفحات لوحة المتصدرين",
    nextPage: "الصفحة التالية",
    mt5Login: "MT5 {login}",
    loading: "جاري تحميل التصنيفات المباشرة…",
    empty: "لا توجد حسابات مسابقة بعد. تظهر التصنيفات عند انضمام حسابات MT5 التجريبية لمجموعة المسابقة.",
    loadError: "تعذر تحميل لوحة المتصدرين المباشرة. يرجى المحاولة مرة أخرى قريبًا.",
    winnersTitle: "الفائزون",
    winnersSubtitle: "مراكز الجوائز على المسرح — مثبتة عند إغلاق المسابقة.",
    verified: "موثّق",
    amount: "المبلغ",
    topTradersTitle: "أبرز المتداولين",
    topTradersSubtitle: "القادة الحاليون المؤهلون للجوائز على المسرح.",
  },
  steps: {
    title: "أربع خطوات للبدء",
    nextStep: "الخطوة التالية",
    items: [
      {
        title: "التسجيل والتحقق",
        description:
          "افتح حسابك بسرعة وبأمان. عملية التحقق المبسطة تجهّزك للتداول خلال دقائق وليس أيام.",
      },
      {
        title: "تمويل الحساب",
        description:
          "أودع بالطريقة التي تفضلها وادخل فوراً إلى بيئة التداول الكاملة مع فتح جميع الأدوات.",
      },
      {
        title: "تداول طوال الشهر",
        description:
          "نفّذ صفقاتك بدقة عبر أسعار ECN تنافسية وتنفيذ سريع على MT4 وMT5 وتطبيق GODO للهاتف.",
      },
      {
        title: "اربح واسحب",
        description:
          "ارتقِ في لوحة المتصدرين، واحصل على حصتك من الجوائز، واسحب مكافآتك بسهولة.",
      },
    ],
  },
  rules: {
    title: "القواعد الرسمية للمسابقة",
    items: [
      {
        title: "الأهلية والتسجيل",
        description:
          "الانضمام مجاني، أكمل اعرف عميلك، حساب واحد لكل مشارك وعنوان IP واحد.",
      },
      {
        title: "معايير التداول",
        description:
          "يجب تنفيذ جميع الصفقات على الحساب التجريبي المخصص بقيمة {balance} خلال الفعالية.",
      },
      {
        title: "الترتيب والتقييم",
        description:
          "الترتيب حسب أعلى حقوق ملكية في النهاية. يُحسم التعادل بخفض نسبة الحد الأقصى للسحب.",
      },
      {
        title: "الاستبعاد",
        description:
          "الحسابات المتعددة أو الممارسات غير العادلة أو إساءة استخدام النظام أو مخالفة القواعد تؤدي إلى الاستبعاد.",
      },
      {
        title: "توزيع الجوائز",
        description:
          "جوائز لأعلى 3 حسابات موثّقة أكملت اعرف عميلك. غير قابلة للتحويل.",
      },
      {
        title: "أحكام عامة",
        description:
          "تحتفظ GODO بالحق في تعديل المسابقة أو تمديدها أو تأجيلها أو إلغائها في أي وقت.",
      },
    ],
  },
  bottomCta: {
    title: "هل أنت مستعد لإثبات تفوقك؟",
    text: "اشتراك مجاني، رأس مال افتراضي، ومكافآت حقيقية. أكمل اعرف عميلك على بوابة GODO واحجز حساب المسابقة.",
  },
  footer: {
    qrAlt: "رمز QR",
    showQr: "عرض رمز QR للتطبيق",
    playStore: "حمّله من Google Play",
    appStore: "حمّله من App Store",
    social: "روابط التواصل",
    scanQr: "امسح الرمز لتنزيل تطبيق GODO",
    copyright: "حقوق النشر © 2026 – جميع الحقوق محفوظة",
    regulationLabel: "التنظيم والترخيص:",
    regulationBody:
      "شركة «GODO LTD» (ترخيص هيئة الخدمات المالية رقم GB20025812) شركة محدودة مرخصة ومسجلة وفقاً لقوانين موريشيوس. نضمن إدارة حسابك بما يتوافق بالكامل مع قواعد ولوائح هيئة الخدمات المالية (FSC). نطاق godocm.com تديره شركة GODO LTD.",
    introductionLabel: "GODO Introduction Financial Services LLC:",
    introductionBody:
      "(ترخيص هيئة الأوراق المالية والسلع رقم: 20200000168) شركة ذات مسؤولية محدودة مرخصة ومسجلة بموجب قانون هيئة الأوراق المالية والسلع في دولة الإمارات العربية المتحدة، وبشراكتها الحصرية مع GODO Limited (موريشيوس) لتقديم الخدمة لمواطني ومقيمي الدولة حصراً. ومع ذلك، لا يُسمح لـ GODO Introduction بحفظ أصول العملاء أو أموالهم، وتُقدَّم جميع الخدمات على أساس التعريف فقط.",
  },
  toast: {
    success: "إشعار نجاح",
    info: "إشعار معلومات",
    warning: "إشعار تنبيه",
    error: "إشعار خطأ",
    dismiss: "إغلاق الإشعار",
    reviewFields: "يرجى التحقق من الحقول المحددة ثم المحاولة مرة أخرى.",
    registerSuccess: "شكراً لك. تم استلام تسجيلك.",
    submitError:
      "تعذر إتمام التسجيل. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، تواصل مع الدعم.",
    alreadyClient:
      "هذا البريد الإلكتروني أو رقم الهاتف مسجّل بالفعل كعميل. يرجى الدخول كمستخدم حالي.",
    alreadyExists:
      "يوجد حساب بهذا البريد الإلكتروني أو رقم الهاتف. استخدم مستخدم حالي للتحقق من أهليتك.",
    documentsRequired:
      "يرجى رفع إثبات الهوية (الوجه الأمامي والخلفي) وإثبات العنوان قبل الإرسال.",
    kycCheckError: "تعذر التحقق من حالة اعرف عميلك. يرجى المحاولة مرة أخرى.",
    accountFound: "تم العثور على حسابك. تظهر بيانات حساب التداول أدناه.",
    rateLimited: "محاولات كثيرة جداً. يرجى الانتظار قليلاً ثم المحاولة مرة أخرى.",
  },
  signup: {
    title: "التسجيل",
    existingUser: "مستخدم حالي",
    newUser: "مستخدم جديد",
    lead: "اختر خياراً للمتابعة.",
    existingHint: "أدخل حسابك للتحقق من حالة اعرف عميلك",
    newHint: "أدخل بياناتك للتسجيل",
    back: "رجوع",
    close: "إغلاق التسجيل",
    accountNumber: "رقم الحساب",
    accountPlaceholder: "أدخل رقم حساب GODO",
    checkKyc: "التحقق من حالة اعرف عميلك",
    checkingKyc: "جارٍ التحقق…",
    registerNow: "سجّل الآن",
    submitting: "جارٍ الإرسال…",
    reviewAndContinue: "مراجعة البيانات",
    reviewTitle: "راجع بياناتك",
    reviewLead:
      "يرجى التأكد من صحة جميع البيانات. يمكنك الرجوع للتعديل، أو التأكيد لإتمام التسجيل.",
    editDetails: "تعديل البيانات",
    confirmRegister: "تأكيد التسجيل",
    reviewDocuments: "المستندات",
    viewFile: "عرض",
    registerSuccessTitle: "تم استلام التسجيل",
    registerSuccessLead:
      "شكراً لك. تم استلام تسجيلك والمستندات قيد المراجعة حالياً. يُرجى حفظ رقم الحساب أدناه للتحقق من الحالة لاحقاً.",
    alreadyExistsTitle: "الحساب موجود بالفعل",
    alreadyExistsLead:
      "يوجد حساب مرتبط بهذا البريد الإلكتروني أو رقم الهاتف. تم تسجيل اهتمامك بالمسابقة. تظهر بيانات الحساب أدناه.",
    registerDone: "تم",
    fullName: "الاسم الكامل (كما في جواز السفر)",
    fullNamePlaceholder: "أدخل الاسم الكامل",
    nickname: "اللقب",
    nicknamePlaceholder: "مثال: AlexTrader",
    nicknameHint: "3–16 حرفاً. أحرف وأرقام وشرطة سفلية.",
    nicknameAvailable: "اللقب متاح.",
    nicknameChecking: "جارٍ التحقق من اللقب…",
    nicknameSuggestions: "جرّب أحد هذه:",
    saveNickname: "حفظ",
    savingNickname: "جارٍ الحفظ…",
    editNickname: "تعديل",
    editDetailsLead: "حدّث بياناتك أدناه. يتم حفظ الحقول التي تغيّرت فقط.",
    editDocumentsHint: "ارفع مستندات جديدة فقط إذا أردت استبدالها. اترك الحقول فارغة للإبقاء على الملفات الحالية.",
    cancel: "إلغاء",
    detailsSaved: "تم حفظ التفاصيل.",
    detailsUnchanged: "لا توجد تغييرات للحفظ.",
    nicknameSaved: "تم حفظ اللقب.",
    nicknameBeforeKyc: "اختر لقبك أولاً. ستظهر بيانات التحقق بعد الحفظ.",
    nicknameSavedWithEmail: "تم حفظ اللقب. تم إرسال رسالة التأكيد.",
    existingContactFound:
      "وجدنا حساباً موجوداً لهذا البريد أو الهاتف. يرجى إكمال الحقول الناقصة أدناه. يبقى قبول الشروط وتأكيد المستفيد الحقيقي إلزامياً.",
    existingContactComplete:
      "وجدنا حساباً موجوداً لهذا البريد أو الهاتف. يرجى قبول الشروط وتأكيد المستفيد الحقيقي للمتابعة.",
    checkingExisting: "جارٍ التحقق من بياناتك…",
    email: "البريد الإلكتروني",
    emailPlaceholder: "أدخل بريداً إلكترونياً صالحاً",
    phone: "رقم الهاتف",
    countryOfResidence: "بلد الإقامة",
    nationality: "الجنسية",
    dualNationality: "الجنسية المزدوجة",
    profession: "المهنة",
    sourceOfFunds: "مصدر الأموال",
    proofOfIdentity: "إثبات الهوية",
    proofOfIdentityBack: "إثبات الهوية (الجهة الخلفية)",
    proofOfAddress: "إثبات العنوان",
    proofOfIdentityInfoLabel: "متطلبات إثبات الهوية",
    proofOfAddressInfoLabel: "متطلبات إثبات العنوان",
    usCitizen: "هل أنت مواطن أمريكي؟",
    yes: "نعم",
    no: "لا",
    hasCode: "هل لديك رمز؟",
    codePlaceholder: "أدخل الرمز",
    chooseFile: "اختر ملفاً",
    typeHere: "اكتب هنا...",
    search: "بحث...",
    noResults: "لا توجد نتائج",
    specify: "حدد {label}",
    searchLabel: "بحث {label}",
    countryCodes: "رموز الدول",
    select: "-- اختر --",
    selectShort: "اختر",
    notApplicable: "غير منطبق",
    approved: "معتمد",
    fullNameShort: "الاسم الكامل",
    emailShort: "البريد الإلكتروني",
    phoneShort: "الهاتف",
    country: "الدولة",
    detailsProfile: "الملف الشخصي",
    detailsLocation: "الموقع",
    detailsCompliance: "الامتثال",
    beneficialOwnerShort: "المالك المستفيد",
    termsAcceptedShort: "تم قبول الشروط",
    kycStatus: "حالة اعرف عميلك",
    kycApproved:
      "تهانينا! تم اعتماد بيانات اعرف عميلك. أنت مؤهل للمشاركة في المسابقة. تحقق من بريدك الإلكتروني للحصول على بيانات حساب التداول، أو تواصل مع cs@godocm.com.",
    kycPending:
      "لست مؤهلاً للمشاركة في المسابقة بعد. يرجى التواصل مع المسؤول عبر cs@godocm.com لإكمال اعتماد اعرف عميلك.",
    kycPendingContactEmail: "cs@godocm.com",
    kycNotFound: "لم يتم العثور على حساب بهذا الرقم.",
    forgotAccount: "نسيت رقم الحساب؟",
    forgotAccountTitle: "اعثر على حسابك",
    recoverLead:
      "أدخل البريد الإلكتروني أو رقم الهاتف المرتبط بحساب تداول GODO لعرض بيانات حسابك.",
    recoverByEmail: "البريد الإلكتروني",
    recoverByPhone: "الهاتف",
    findAccount: "اعثر على حسابي",
    recoverFound: "وجدنا حسابك. يظهر رقم حساب التداول وبياناتك أدناه.",
    recoverNotFound: "لم يتم العثور على حساب بهذه البيانات.",
    notApproved: "قيد المراجعة",
    beneficialOwnerBefore:
      "أؤكد أنني المالك المستفيد والمتداول المفوّض لهذا الحساب. وإن لم يكن كذلك، فقد قدّمت ",
    powerOfAttorney: "توكيل رسمي",
    beneficialOwnerAfter: "",
    termsBefore:
      "بتأكيد التسجيل، أؤكد أنني: (1) قرأت وفهمت ووافقت على ",
    termsOfBusiness: "شروط العمل",
    termsAfter:
      "، (2) أوافق على تواصل GODO معي في أي وقت مناسب، و(3) أن رقمي غير مسجّل في سجل عدم الاتصال (DNCR).",
    competitionTermsBefore: "لقد قرأت ",
    competitionTermsLink: "شروط وأحكام المسابقة",
    competitionTermsAfter: " وأوافق عليها.",
    proofOfIdentityIntro:
      "يُرجى تقديم واحدة على الأقل من الوثائق التالية على أن تتضمن الاسم القانوني وأن تكون سارية، مع تاريخ الميلاد والجنسية ورقم الهوية المسجّل:",
    proofOfIdentityItems: [
      "جواز السفر - لأي جنسية",
      "الهوية الإماراتية إذا كان العميل مقيماً في الدولة",
      "أي هوية حكومية أخرى تتضمن هذه البيانات",
    ],
    proofOfAddressIntro:
      "يُرجى تقديم واحدة على الأقل من الوثائق التالية على أن تبيّن عنوان الإقامة الحالي أو الدائم كما في نموذج الطلب وأن تكون صادرة خلال آخر 3 أشهر تقويمية",
    proofOfAddressItems: [
      "فواتير أو كشوف خدمات عامة مثل الكهرباء أو الماء أو الغاز أو الهاتف",
      "عقد إيجار (يجب أن يكون ضمن مدة العقد)",
      "وثائق حكومية محلية أو وطنية بما في ذلك سجلات الضرائب البلدية أو ما شابهها",
      "عقود شراء أو إيجار عقار مسجّلة",
      "وثائق من مؤسسات مالية خاضعة للرقابة مثل كشوف الحساب أو وثائق التأمين.",
      "إذا كان العميل يقيم في سكن مشترك أو إيجار قصير الأجل، يجوز تقديم وثيقة الإقامة الدائمة حسب جنسيته.",
    ],
    professionOptions: {
      employed: "موظف",
      "self-employed": "عمل حر",
      "business-owner": "صاحب عمل",
      student: "طالب",
      management: "إدارة",
      unemployed: "بدون عمل",
      other: "أخرى",
    },
    fundsOptions: {
      salary: "راتب",
      savings: "مدخرات",
      pension: "تقاعد",
      "profits-dividends": "أرباح / توزيعات",
      "sale-of-assets": "بيع أصول",
      "crypto-investments": "استثمارات رقمية",
      "inheritance-gifts": "إرث وهدايا",
      other: "أخرى",
    },
    errors: {
      accountRequired: "يرجى إدخال رقم الحساب.",
      accountInvalid: "أدخل رقم حساب صالحاً (4–20 حرفاً أو رقماً).",
      fullNameRequired: "يرجى إدخال اسمك الكامل كما في جواز السفر.",
      fullNameShort: "يجب أن يتكون الاسم الكامل من حرفين على الأقل.",
      fullNameLetters: "الاسم الكامل يمكن أن يحتوي على أحرف ومسافات وشرطات وعلامات اقتباس فقط.",
      emailRequired: "يرجى إدخال بريدك الإلكتروني.",
      emailInvalid: "يرجى إدخال بريد إلكتروني صالح.",
      phoneRequired: "يرجى إدخال رقم الهاتف.",
      phoneInvalid: "يرجى إدخال رقم هاتف صالح.",
      countryRequired: "يرجى اختيار بلد الإقامة.",
      countryNotEligible: "هذه المسابقة متاحة فقط في دول محددة. موقعك الحالي غير مؤهل.",
      nationalityRequired: "يرجى اختيار الجنسية.",
      professionRequired: "يرجى اختيار المهنة.",
      professionOther: "يرجى تحديد المهنة.",
      professionOtherLetters: "المهنة يمكن أن تحتوي على أحرف ومسافات فقط.",
      fundsRequired: "يرجى اختيار مصدر الأموال.",
      fundsOther: "يرجى تحديد مصدر الأموال.",
      fundsOtherLetters: "مصدر الأموال يمكن أن يحتوي على أحرف ومسافات فقط.",
      identityRequired: "يرجى رفع إثبات الهوية.",
      identityBackRequired: "يرجى رفع الجهة الخلفية لوثيقة الهوية.",
      addressRequired: "يرجى رفع إثبات العنوان.",
      usCitizenRequired: "يرجى تحديد ما إذا كنت مواطناً أمريكياً.",
      beneficialOwner: "يرجى تأكيد أنك المالك المستفيد.",
      terms: "يرجى قبول الشروط للمتابعة.",
      competitionTerms: "يرجى قراءة شروط وأحكام المسابقة وقبولها للمتابعة.",
      referral: "يرجى إدخال الرمز.",
      referralInvalid: "رمز الإحالة يمكن أن يحتوي على أحرف وأرقام وشرطات فقط.",
      nicknameRequired: "يرجى اختيار لقب.",
      nicknameLength: "يجب أن يكون اللقب من 3 إلى 16 حرفاً.",
      nicknameInvalid: "ابدأ بحرف، ثم استخدم أحرفاً وأرقاماً وشرطة سفلية فقط. بدون مسافات.",
      nicknameReserved: "هذا اللقب محجوز. يرجى اختيار اسم آخر.",
      nicknameTaken: "هذا اللقب مستخدم. يرجى اختيار اسم آخر.",
      fileType: "يرجى رفع ملف JPEG أو PNG أو WEBP أو PDF فقط.",
      fileTooLarge: "يجب ألا يتجاوز حجم كل ملف 10 ميغابايت.",
      fileUploadFailed: "فشل رفع الملف. يرجى المحاولة مرة أخرى بملف مدعوم.",
    },
  },
};

export default ar;
